module.exports = __webpack_public_path__ + "img/d2.0f9e1cf0.jpg";